import React from 'react';
import { URLS } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import ArrowRight from '@wix/da-ds/pkg/Icons/ArrowRight';
import { ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import LoadingIndicator from '../../../LoadingIndicator';
import StreamedList from '../../../StreamedList';
import BasicUserAvatar from '../../../User/_partials/BasicUserAvatar';
import s from './GroupsList.scss';
const GroupsList = ({ headerContent , groups , onSelect , isFetching , deviationId , streamId , filterValue  })=>{
    const { t  } = useTranslation();
    const isEmpty = !isFetching && groups.length === 0;
    return isFetching && !groups.length ? /*#__PURE__*/ React.createElement(LoadingIndicator, {
        view: "llama",
        className: s['loader']
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, headerContent, isEmpty ? /*#__PURE__*/ React.createElement(Section, {
        className: s['empty']
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: s['empty-header']
    }, t('addToGroupPopup.empty.header')), /*#__PURE__*/ React.createElement("div", {
        className: s['empty-text']
    }, t('addToGroupPopup.empty.text')), /*#__PURE__*/ React.createElement(GhostButton, {
        className: s['empty-cta-button'],
        variant: "approval-green",
        size: "medium",
        href: URLS.GROUPS,
        biData: BiData({
            evid: 2,
            click_info: 'addToGroup.emptyState',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue
        })
    }, t('addToGroupPopup.empty.CTA.button'))) : /*#__PURE__*/ React.createElement(StreamedList, {
        streamId: streamId,
        className: s['list'],
        wrapperClassName: s['scrollable']
    }, groups.map((group)=>!filterValue || group.username.toLowerCase().includes(filterValue.toLowerCase()) ? /*#__PURE__*/ React.createElement(ListItemButton, {
            key: group.userId,
            onClick: ()=>onSelect(group),
            biData: BiData({
                evid: 341,
                deviationid: deviationId,
                groupid: group.useridUuid,
                source_type: BiContextProvidedValue
            }),
            label: group.username,
            prefix: /*#__PURE__*/ React.createElement(BasicUserAvatar, {
                user: group,
                size: 35
            }),
            suffixIcon: ArrowRight,
            fillContainerWidth: true,
            showSuffixOnlyOnHover: true
        }) : null)));
};
GroupsList.displayName = 'GroupsList';
export default GroupsList;
